export default class CartEvents {

    static cartModifiedEvents : Array<any> = [];

    static addCartModifiedEvent(event: any) {
        CartEvents.cartModifiedEvents.push(event);
    }

    static callCartModifiedEvents() {
        CartEvents.cartModifiedEvents.forEach((event: any) => {
            event();
        });
    }
 static removeCartModifiedEvent(eventToRemove: () => void) {
        CartEvents.cartModifiedEvents = CartEvents.cartModifiedEvents.filter(
            (event) => event !== eventToRemove
        );
    }
}